module.exports = __webpack_public_path__ + "static/img/culture1.9240db1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/culture1.png
// module id = YL7Y
// module chunks = 1